// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JournalViewAll_journals__8GZU7::-webkit-scrollbar {
  display: none;
  width: 0;
}
.JournalViewAll_journals__8GZU7 .JournalViewAll_journal-list__NmbCs {
  max-width: 777px;
  margin: auto;
}
@media screen and (min-width: 1600px) {
  .JournalViewAll_journals__8GZU7 .JournalViewAll_journal-list__NmbCs {
    max-width: 1000px;
  }
}
.JournalViewAll_journals__8GZU7 .JournalViewAll_addJournalButton__EAdh0:focus {
  outline: 2px solid olive;
  background-color: green;
}
.JournalViewAll_journals__8GZU7 .JournalViewAll_addJournalButton__EAdh0:focus::after {
  content: "Press Enter or Space to add a new journal";
  display: block;
  margin-top: 10px;
  font-size: 0.8em;
  color: white;
}

.JournalViewAll_medieval__Bggop {
  background: linear-gradient(rgba(139, 69, 19, 0.2), rgba(93, 78, 61, 0.2));
  color: #5D4E3D;
}
.JournalViewAll_medieval__Bggop h1, .JournalViewAll_medieval__Bggop h3 {
  font-family: "Times New Roman", serif;
  text-decoration: underline;
}
.JournalViewAll_medieval__Bggop .JournalViewAll_parchment-search__7Zun3 {
  background: rgba(255, 248, 220, 0.9);
  border: 2px solid #5D4E3D;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
}
.JournalViewAll_medieval__Bggop .JournalViewAll_medieval-input__PF6GZ {
  background: rgba(255, 248, 220, 0.9);
  border: 2px solid #5D4E3D;
  border-radius: 4px;
  font-family: "Times New Roman", serif;
  padding: 10px;
  margin-bottom: 20px;
}
.JournalViewAll_medieval__Bggop .JournalViewAll_custom-skeleton__uQYb1 {
  width: 100%;
  height: 24px;
  background-color: rgba(93, 78, 61, 0.5);
  margin-bottom: 10px;
  border-radius: 4px;
}
.JournalViewAll_medieval__Bggop button {
  background-color: #8B4513;
  color: #fff;
  border: 2px solid #5D4E3D;
}
.JournalViewAll_medieval__Bggop button:hover {
  background-color: #5e2f0d;
}

.JournalViewAll_parchment__8QJgb {
  background: rgba(255, 248, 220, 0.9);
  margin: 1rem;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Journals/JournalViewAll.module.scss"],"names":[],"mappings":"AACI;EACG,aAAA;EACA,QAAA;AAAP;AAEI;EACI,gBAAA;EACA,YAAA;AAAR;AAEQ;EAJJ;IAKQ,iBAAA;EACV;AACF;AAGQ;EACI,wBAAA;EACA,uBAAA;AADZ;AAIY;EACI,oDAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAFhB;;AA0BE;EACE,0EAAA;EACA,cAAA;AAvBJ;AAyBI;EACI,qCAAA;EACA,0BAAA;AAvBR;AA8BI;EACI,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;AA5BR;AA8BI;EACI,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;AA5BR;AA+BI;EACI,WAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;AA7BR;AAgCI;EACI,yBAAA;EACA,WAAA;EACA,yBAAA;AA9BR;AAgCQ;EACI,yBAAA;AA9BZ;;AAmCA;EACI,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;AAhCJ","sourcesContent":[".journals {\n    &::-webkit-scrollbar {\n       display: none;\n       width: 0;\n    }\n    .journal-list {\n        max-width: 777px;\n        margin: auto;\n\n        @media screen and (min-width: 1600px) {\n            max-width: 1000px;\n        }\n    }\n\n    .addJournalButton {\n        &:focus {\n            outline: 2px solid olive; // Highlighted focus\n            background-color: green; // Change background color on focus\n\n            // Pseudo-element for displaying instruction\n            &::after {\n                content: 'Press Enter or Space to add a new journal';\n                display: block;\n                margin-top: 10px;\n                font-size: 0.8em;\n                color: white;\n            }\n        }\n    }\n\n\n   //  .journal-container {\n   //      @media screen and (max-width: 600px) {\n   //         // display: none;\n   //         width: 0;\n   //         position: fixed;\n   //         left: 100vw;\n   //      }\n  \n   //      .placeholder {\n   //         padding: 40px;\n   //         text-align: center;\n   //         color: rgb(90, 90, 90);\n   //      }\n   //   }\n}\n\n\n\n  .medieval {\n    background: linear-gradient(rgba(139, 69, 19, 0.2), rgba(93, 78, 61, 0.2));\n    color: #5D4E3D; // A medieval-like brown color for text\n\n    h1, h3 {\n        font-family: 'Times New Roman', serif; // A font that can simulate a medieval look\n        text-decoration: underline;\n    }\n\n    // .custom-skeleton {\n    //     background-color: rgba(93, 78, 61, 0.5); // A transparent medieval-like brown for the skeleton\n    // }\n\n    .parchment-search {\n        background: rgba(255, 248, 220, 0.9);  // Parchment-like color\n        border: 2px solid #5D4E3D;\n        padding: 1rem;\n        border-radius: 15px;\n        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\n    }\n    .medieval-input {\n        background: rgba(255, 248, 220, 0.9);  // Parchment-like color\n        border: 2px solid #5D4E3D;\n        border-radius: 4px;\n        font-family: 'Times New Roman', serif;\n        padding: 10px;\n        margin-bottom: 20px;\n    }\n\n    .custom-skeleton {\n        width: 100%;\n        height: 24px;\n        background-color: rgba(93, 78, 61, 0.5); // A transparent medieval-like brown for the skeleton\n        margin-bottom: 10px;\n        border-radius: 4px;\n      }\n\n    button {\n        background-color: #8B4513; // A brownish color for buttons\n        color: #fff;\n        border: 2px solid #5D4E3D; // Border to make it stand out\n\n        &:hover {\n            background-color: darken(#8B4513, 10%);\n        }\n    }\n}\n\n.parchment {\n    background: rgba(255, 248, 220, 0.9);  // Parchment color background\n    margin: 1rem;\n    padding: 1rem;\n    border-radius: 15px;\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"journals": `JournalViewAll_journals__8GZU7`,
	"journal-list": `JournalViewAll_journal-list__NmbCs`,
	"addJournalButton": `JournalViewAll_addJournalButton__EAdh0`,
	"medieval": `JournalViewAll_medieval__Bggop`,
	"parchment-search": `JournalViewAll_parchment-search__7Zun3`,
	"medieval-input": `JournalViewAll_medieval-input__PF6GZ`,
	"custom-skeleton": `JournalViewAll_custom-skeleton__uQYb1`,
	"parchment": `JournalViewAll_parchment__8QJgb`
};
export default ___CSS_LOADER_EXPORT___;
